import { Doughnut } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js'

ChartJS.register(ArcElement, Tooltip)

// Band cutoffs mirror the backend scoring config (band_critical=80 … band_low=20)
// so the gauge color matches the worst-band semantics elsewhere in the portal.
// eslint-disable-next-line react-refresh/only-export-components
export function gaugeColor(score: number): string {
  if (score >= 80) return '#C22221' // critical
  if (score >= 60) return '#e8734f' // high
  if (score >= 40) return '#eab308' // medium
  if (score >= 20) return '#94C8E4' // low
  return '#94a3b8' // info
}

export function RiskGauge({ score, size = 96 }: { score: number; size?: number }) {
  const clamped = Math.max(0, Math.min(100, Math.round(score)))
  const color = gaugeColor(clamped)
  return (
    <div className="relative shrink-0" style={{ height: size, width: size }}>
      <Doughnut
        data={{
          datasets: [
            {
              data: [clamped, 100 - clamped],
              backgroundColor: [color, 'rgba(148,163,184,0.18)'],
              borderWidth: 0,
              circumference: 360,
            },
          ],
        }}
        options={{
          cutout: '78%',
          responsive: true,
          maintainAspectRatio: false,
          plugins: { legend: { display: false }, tooltip: { enabled: false } },
        }}
      />
      <div className="absolute inset-0 grid place-items-center">
        <span
          className="font-bold text-text-light dark:text-text-dark"
          style={{ fontSize: Math.round(size * 0.28) }}
        >
          {clamped}
        </span>
      </div>
    </div>
  )
}
